// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"288":"19a2c651","749":"e73c03ce","757":"1cfa2bc6"}[chunkId] + ".chunk.css";
};